L.Control.AttributionInfo = L.Control.extend({
  options: {
    position: "bottomright",
  },

  _isVisible: false,

  onAdd: function (map) {
    this._map = map;

    let attributionText = Object.keys(map.attributionControl._attributions)[0];

    // create controler container
    var container = L.DomUtil.create(
      "div",
      "leaflet-control-attribution-info leaflet-control"
    );

    // remove old attribution control
    map.removeControl(map.attributionControl);

    if (attributionText) {
      // add attribution container
      this.attributionContainer = L.DomUtil.create(
        "div",
        "leaflet-control-attribution-container",
        container
      );

      // add button
      this.button = L.DomUtil.create(
        "button",
        "sl-ic-1-info1",
        container
      );

      // add on button click listener
      L.DomEvent.on(this.button, "click", this._click, this);

      this.attributionContainer.innerHTML = "<span>" + attributionText + "</span>";
    }

    return container;
  },

  _click: function (e) {
    L.DomEvent.stopPropagation(e);
    L.DomEvent.preventDefault(e);
    if (this._isVisible) {
      this._hideAttribution();
    } else {
      this._showAttribution();
    }
    this._isVisible = !this._isVisible;
  },

  _showAttribution: function () {
    this.attributionContainer.style.display = "inline-block";
    this.button.style.borderBottomLeftRadius = "0";
    this.button.style.borderTopLeftRadius = "0";
  },

  _hideAttribution: function () {
    this.attributionContainer.style.display = "none";
    this.button.style.borderBottomLeftRadius = "100%";
    this.button.style.borderTopLeftRadius = "100%";
  }

});

L.control.attributionInfo = function (options) {
  return new L.Control.AttributionInfo(options);
};
